module.exports = __webpack_public_path__ + "static/media/avettiLogo.59d76482.png";